import { useAuth } from "@/context/authContext";
import { api } from "@/utils/api";
import { useState } from "react";
import { toast } from "sonner";

export const useRotations = ({
  archived = false,
}: { archived?: boolean } = {}) => {
  const { dispatch } = useAuth();
  const [loading, setLoading] = useState<{
    loadRotations: boolean;
  }>({ loadRotations: false });

  const loadRotations = async (
    setRotations: (data: { rotations: any[]; sessions: any[] }) => void,
  ) => {
    try {
      setLoading((prev) => ({ ...prev, loadRotations: true }));
      const response = await api(
        `/rotations?shape=all${archived ? "&archived=true" : ""}`,
        { method: "GET" },
        dispatch,
      );
      setRotations({
        rotations: response.rotations,
        sessions: response.sessions,
      });
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, loadRotations: false }));
    }
  };

  return { loadRotations, loading };
};
